import PropTypes from 'prop-types';
import React from 'react';
import { Button, OverlayTrigger, Popover } from 'react-bootstrap';
import { FormattedMessage, injectIntl } from 'react-intl';
import {
  Address,
  Phone,
  Name,
  Email,
  getFormattedName,
} from 'ecs-react-components/dist/index.es';

import { careProviderSelected } from '../../redux/modules/secure-message/actions/creators';
import { messages } from './CareTeamMemberCard.i18n';
import SecureMessageForm from '../../containers/SecureMessage/SecureMessageForm';

class CareTeamMemberCard extends React.Component {
  constructor() {
    super();
    this.state = {
      showModal: false,
    };
  }

  onSendButtonClick = () => {
    this.props.dispatch(careProviderSelected(this.props.careTeamMember.careProviderId));
    this.setState({ showModal: true });
  };

  getNumberOfLines = () => {
    const {
      careTeamMember,
    } = this.props;


    let maxLengthBeforeNameWraps = 39;
    let maxLengthBeforeAddress1Wraps = 41;
    let maxLengthBeforeAddress2Wraps = 41;
    if (this.props.windowSize === 'large') {
      maxLengthBeforeNameWraps = 45;
      maxLengthBeforeAddress1Wraps = 41;
      maxLengthBeforeAddress2Wraps = 41;
    } else if (this.props.windowSize === 'medium') {
      maxLengthBeforeNameWraps = 29;
      maxLengthBeforeAddress1Wraps = 30;
      maxLengthBeforeAddress2Wraps = 30;
    } else if (this.props.windowSize === 'small') {
      maxLengthBeforeNameWraps = 36;
      maxLengthBeforeAddress2Wraps = 38;
    } else if (this.props.windowSize === 'xsmall') {
      maxLengthBeforeNameWraps = 56;
    } else {
      maxLengthBeforeNameWraps = 39;
      maxLengthBeforeAddress1Wraps = 41;
      maxLengthBeforeAddress2Wraps = 41;
    }

    let counter = 1; // Account for name line. It will always be present.
    if (getFormattedName(this.getPersonName()).length > maxLengthBeforeNameWraps) {
      counter += 1;
    }
    if (careTeamMember.address1) {
      counter += 1;
    }
    if (careTeamMember.address1 && careTeamMember.address1.length > maxLengthBeforeAddress1Wraps) {
      counter += 1;
    }
    if (careTeamMember.address2) {
      counter += 1;
    }
    if (careTeamMember.address2 && careTeamMember.address2.length > maxLengthBeforeAddress2Wraps) {
      counter += 1;
    }

    if (careTeamMember.publicEmail) {
      counter += 1;
    }

    if (careTeamMember.publicPhone) {
      counter += 1;
    }
    if (careTeamMember.fax) {
      counter += 1;
    }

    return counter;
  }

  getContactInfoOverlay = () => (
    <Popover title={this.props.intl.formatMessage(messages.popOverTitle)}>
      {this.renderContactInfoFull()}
    </Popover>
  );

  getPersonName() {
    return {
      firstName: this.props.careTeamMember.firstName,
      lastName: this.props.careTeamMember.lastName,
      suffix: this.props.careTeamMember.suffix,
      title: this.props.careTeamMember.careProviderTitle };
  }

  getContainerClassName = () => {
    let className = 'col-xs-9';
    if (!this.props.careTeamMember.userProfileImageUrl) {
      className = 'col-xs-12';
    }
    return className;
  }

  closeModal = () => {
    this.setState({ showModal: !this.state.showModal });
  }

  renderContactInfoFull = () => {
    const { careTeamMember } = this.props;
    return (
      <div tabIndex={-1}>
        <strong><Name name={this.getPersonName()} otherProperties={{ tabIndex: -1 }} /></strong>
        <Address otherProperties={{ tabIndex: -1 }} address={
          {
            address1: careTeamMember.address1,
            address2: careTeamMember.address2,
          }
            }
        />
        <Email otherProperties={{ tabIndex: -1 }} email={this.props.careTeamMember.publicEmail} />
          <Phone
            otherProperties={{ tabIndex: -1 }}
            phone={ careTeamMember.publicPhone }
            fax={ careTeamMember.fax }
          />
      </div>);
  }

  renderContactInfoSubset = () => {
    const numberOfLines = this.getNumberOfLines();
    const { careTeamMember } = this.props;
    const describedById = 'describedById_' + careTeamMember.contactId;
    return (
      <div className="careteam-card-description">
          {this.renderPhoto()}
        <div className={this.getContainerClassName()}>
          <div className="contact-info">
            <strong><Name name={this.getPersonName()} otherProperties={{ tabIndex: 0 }} /></strong>&nbsp;
            <Address
              address={
                {
                  address1: numberOfLines > 10 ? null : careTeamMember.address1,
                  address2: numberOfLines > 9 ? null : careTeamMember.address2,
                }
              }
              otherProperties={{ tabIndex: 0 }}
            />
            { numberOfLines > 7 ? null : <Email email={careTeamMember.publicEmail} otherProperties={{ tabIndex: 0 }} />}
            <Phone
              phone={ numberOfLines > 6 ? null : careTeamMember.publicPhone}
              fax={ numberOfLines > 6 ? null : careTeamMember.fax }
              otherProperties={{ tabIndex: 0 }}
            />
            { numberOfLines > 6 ? this.renderMoreLink(describedById) : null }
            { numberOfLines > 6 ? this.renderDescribedByHiddenDetail(describedById) : null }
          </div>
        {this.renderSecureMessageButton()}
        </div>
      </div>
    );
  }

  renderDescribedByHiddenDetail = (describedById) => (
    <div className="sr-only" id={describedById}>
      {this.renderContactInfoFull()}
    </div>
  );

  /* eslint jsx-a11y/img-redundant-alt:0 */
  renderPhoto() {
    if (this.props.careTeamMember.userProfileImageUrl) {
      return (
          <div className="col-xs-3">
            <div className="user-image">
              <img className="img-responsive" alt="no image"
                src={ this.props.careTeamMember.userProfileImageUrl }
              />
            </div>
          </div>);
    }
    return null;
  }

  renderMoreLink = (describedById) => (
    <OverlayTrigger trigger="click" rootClose placement="top" overlay={this.getContactInfoOverlay()}>
      <div>
        <button tabIndex="0" className="linkbutton" aria-describedby={describedById}>
        <FormattedMessage {...messages.moreLink} />
        </button>
      </div>
    </OverlayTrigger>
  );

  renderSecureMessageButton() {
    if (this.props.careTeamMember.preferredSecureMessageIfSystemId &&
        this.props.careTeamMember.preferredSecureMessageIfSystemId > 0 &&
        this.props.careTeamMember.secureMessageRecipientForPatient) {
      return (
        <Button onClick={this.onSendButtonClick}
          className="btn btn-link float-right" role="link"
        >
          <span className="fa fa-envelope" aria-hidden="true">
          </span>
          <FormattedMessage {...messages.securemessage} />
        </Button>);
    }

    return null;
  }

  render() {
    return (
        <div className="panel panel-default description-box notheme">
          <div className="panel-body">
            <div className="row">
              {this.renderContactInfoSubset()}
              <SecureMessageForm showModal={ this.state.showModal } close={ this.closeModal } />
            </div>
          </div>
        </div>
    );
  }
}

CareTeamMemberCard.propTypes = {
  careTeamMember: PropTypes.object.isRequired,
  displayPhoto: PropTypes.bool,
  dispatch: PropTypes.func,
  intl: PropTypes.object,
  windowSize: PropTypes.string,
};

CareTeamMemberCard.defaultProps = {
  displayPhoto: true,
};

export default injectIntl(CareTeamMemberCard);